// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"ScrollToTop_scrollToTop__T53Em","arrow":"ScrollToTop_arrow__6j0Qt","hidden":"ScrollToTop_hidden__L1pnf"};